module.exports = __webpack_public_path__ + "img/LT.f4c76035.png";